<template>
    <div>
        <i @click="$emit('click')" :id="iconId" :class="icon"></i>
    </div>
</template>
<script>
/**
 * Renders the icon passed as prop. You can to style it by passing more props: Color, Size, and Opacity.
 * @displayName FixitIcon
 */
export default {
    name: 'FIcon',
    props: {
        color: {
            type: String,
            default: '#000000'
        },
        size: {
            type: String,
            default: '24px'
        },
        icon: {
            type: String,
            default: ''
        },
        opacity: {
            type: String,
            default: '100%'
        },
    },
    computed: {
        iconId() {
            return this.icon + Math.floor(Math.random() * 100000);
        }
    },
    mounted() {
        let icon = document.getElementById(`${this.iconId}`)
        if (this.size.includes("px")) icon.style.fontSize = this.size
        else icon.style.fontSize = (parseFloat(this.size) * 24).toString() + "px"
        icon.style.opacity = this.opacity
        
        //Set the color
        var sheet = (function() {
            var style = document.createElement("style");
            style.appendChild(document.createTextNode(""));
            document.head.appendChild(style);
            return style.sheet;
        })();
        sheet.insertRule(`#${this.iconId}:before { color: ${this.color}; }`, 0);
    }
}
</script>
<style scoped>
    @import '../assets/FixitIcons-v-1.0/style.css';
</style>
